{{ 'Project::GenerativeQuestionAnsweringTrainedSuccessfully' | abpLocalization: notification.name }}
